import type { AttributeValue } from "@/lib/catalog/types";

/** String used for select / multiselect option values (API may store numbers in JSON). */
export function attributeScalarToOptionString(v: AttributeValue | undefined): string {
  if (v == null) return "";
  if (typeof v === "string") return v;
  if (typeof v === "number" && Number.isFinite(v)) return String(v);
  if (typeof v === "boolean") return v ? "true" : "false";
  return "";
}
